import { render } from "./DiffRomb.vue?vue&type=template&id=7fffd510&scoped=true"
import script from "./DiffRomb.vue?vue&type=script&lang=js"
export * from "./DiffRomb.vue?vue&type=script&lang=js"

import "./DiffRomb.vue?vue&type=style&index=0&id=7fffd510&scoped=true&lang=css"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fffd510"]])

export default __exports__